import { useState } from "react";

export default function ShareBar({ title }: { title: string }) {
  const [copied, setCopied] = useState(false);

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const weiboUrl = `https://91chigua1.asia/share/share.php?url=${encodedUrl}&title=${encodedTitle}`;
  const qqUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${encodedUrl}&title=${encodedTitle}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const linkClass =
    "flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-100/70 px-4 py-2.5 text-sm font-label text-foreground-700 transition-colors duration-200 hover:border-primary-500/60 hover:text-primary-400";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button type="button" onClick={copyLink} className={`${linkClass} cursor-pointer`}>
        <i className={copied ? "ri-check-line text-primary-400" : "ri-link"} />
        {copied ? "已复制链接" : "复制链接"}
      </button>
      <a href={weiboUrl} target="_blank" rel="noopener noreferrer" className={linkClass}>
        <i className="ri-weibo-fill" />
        微博
      </a>
      <a href={qqUrl} target="_blank" rel="noopener noreferrer" className={linkClass}>
        <i className="ri-qq-fill" />
        QQ
      </a>
    </div>
  );
}